export default __webpack_public_path__ + "static/media/MOTIVO_10.09c3c179.jpg";